// Shared navigation logic: menu toggle + active link highlighting

function normalizeCurrentPath(): string {
  try {
    let current = window.location.pathname.split('/').pop() || '';
    if (!current) current = 'index.html';
    if (current.indexOf('.') === -1) current = current + '.html';
    return current;
  } catch (_) {
    return 'index.html';
  }
}

function highlightCurrentLink(menu: HTMLElement | null) {
  if (!menu) return;
  try {
    const links = menu.querySelectorAll('a');
    const current = normalizeCurrentPath();
    links.forEach(a => a.classList.remove('current'));
    for (const a of Array.from(links)) {
      const href = (a.getAttribute('href') || '').split('/').pop() || '';
      if (!href) continue;
      if (href === current || (current === 'index.html' && (href === '/' || href === 'index.html'))) {
        a.classList.add('current');
        break;
      }
    }
  } catch (_) {
    // no-op
  }
}

function setupMenuToggle(menuBtn: HTMLElement | null, menu: HTMLElement | null) {
  if (!menuBtn || !menu) return;

  menuBtn.addEventListener('click', function () {
    menu.classList.toggle('active');
  });

  // Hide menu when clicking outside on small screens
  document.addEventListener('click', function (e) {
    if (window.innerWidth <= 950 && menu.classList.contains('active')) {
      const target = e.target as Node;
      if (!menu.contains(target) && !menuBtn.contains(target as Node)) {
        menu.classList.remove('active');
      }
    }
  });
}

function initNav() {
  const menuBtn = document.querySelector('.menu-toggle') as HTMLElement | null;
  const menu = document.getElementById('templatemo-menu') as HTMLElement | null;

  setupMenuToggle(menuBtn, menu);
  highlightCurrentLink(menu);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNav);
} else {
  initNav();
}
